export default "<div *ngIf=\"hasChanges\" class=\"changes-indicator\" (click)=\"showChanges()\">{{ 'pa.lastChanges.showLastChanges' | translate }}</div>\n"